module.exports = "query Campaigns (\n  $perkId: String,\n  $page: Int = 1,\n  $limit: Int = 100000,\n  $asc: String = \"name\",\n  $status: String,\n  $exclusive: String,\n  $highlight: String,\n  $cashback: String\n) {\n  campaigns (\n    partner: $perkId,\n    page: $page,\n    limit: $limit,\n    asc: $asc,\n    status: $status,\n    exclusive: $exclusive,\n    highlight: $highlight,\n    cashback: $cashback\n  ) {\n    data {\n      id\n      name\n      partner {\n        name\n      }\n      status\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/CampaignsCashback.graphql
// module id = DtKF
// module chunks = 1624